
<div class="mt-1 app-left-margin app-right-margin w-100 " v-resize="onResize">
    <c-app-bar
        title          = "OUTBOX"
        :categories    = "[]"
        :enable-search = "false"
    >
        <template v-slot:search>
            <v-spacer />
        </template>
    </c-app-bar>

    <p-inc-outbox
        :search = "search"
        :height = "height"
    />
</div>
